import { FC } from 'react'
import { CurrencyUnit, ISubsidyBase } from '@/types'
import { getDateTimeFromUtc, getFormattedAmount } from '@/utils'
import { IconTextItem } from '@components-v2/atoms/IconTextItem'
import BankNoeSvg from '@/public/images/common/bank-note-01_v2.svg'
import CaledarSVg from '@/public/images/common/calendar_v2.svg'
import MarkerPinSvg from '@/public/images/common/marker-pin-01_v2.svg'
import styles from './index.module.scss'

type Props = {
  subsidy: ISubsidyBase
}

export const SubsidyAttributes: FC<Props> = ({ subsidy }) => {
  const formattedApplicationStartAtt = getDateTimeFromUtc(subsidy?.applicationStartAt, 'YYYY年MM月DD日')
  const formattedMaxAmount = getFormattedAmount(Number(subsidy?.maximumAmount), CurrencyUnit.JPY) || ''
  return (
    <div className={styles.container}>
      {/* locations */}
      {subsidy?.locations?.length > 0 && (
        <IconTextItem icon={<MarkerPinSvg viewBox='0 0 24 24' />} nameList={subsidy?.locations.map((l) => l.name)} />
      )}

      {/* applicationStartAt */}
      <IconTextItem icon={<CaledarSVg viewBox='0 0 20 20' />} nameList={[`${formattedApplicationStartAtt}〜`]} />

      {/* maximumAmount */}
      <IconTextItem icon={<BankNoeSvg viewBox='0 0 24 24' />} nameList={[formattedMaxAmount]} />
    </div>
  )
}
